import React from 'react'
import { Layout, Row, Col, Menu, Avatar, Button } from 'antd'
import { logoutUser } from '../../actions/auth';
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";

import './index.less'

const { Header } = Layout;

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userIsLoading: state.userIsLoading,
    errorMessage: state.errorMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    tryLogout: () => dispatch(logoutUser()),
  }
}

class commonHeader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      needToLogout: false 
    }
    this.accountMenu = this.accountMenu.bind(this)
    this.menuSelectHandler = this.menuSelectHandler.bind(this)
  }


  componentWillUpdate(nextProps) {
    if (!nextProps.user.username) {
      this.setState({needToLogout:true})
    }
  }

  menuSelectHandler(data) {
    this.props.tryLogout()
    this.props.needToLogoutHandler(true)
  }

  accountMenu() {
    return (
      <Menu
        onSelect={(e) => this.menuSelectHandler(e)}
        >
      </Menu>
    )
  }


  render () {
    let username = this.props.user.username
      if (this.state.needToLogout) {
        this.props.needToLogoutHandler(true)
        return (
          <Redirect to="/login" />
        )
      } else {
        return (
          <Header style={{ background: '#fff', padding: 0 }}>
            <Row type="flex" justify="end" align="middle">
              <Col xs={2} sm={2} md={1}>
                <Row type="flex" justify="center">
                    <Link to="/profile">
                      <Avatar style={{ verticalAlign: 'middle'}}>{username}</Avatar>
                    </Link>
                </Row>
              </Col>
              <Col xs={4} sm={3} md={2}>
                <Row type="flex" justify="center">
                  <Button 
                    ghost
                    type="primary"
                    size="small"
                    onClick={(e) => this.menuSelectHandler(e)}>
                    Logout
                  </Button>
                </Row>
              </Col>
            </Row>
          </Header>
        )
      }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(commonHeader)



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx